String.prototype.turkishToLower = function () {
  var string = this;
  var letters = { İ: "i", I: "i" };
  string = string.replace(/(([İI]))/g, function (letter) {
    return letters[letter];
  });
  return string.toLowerCase();
};
